var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsBpFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192,273l-20.26,11.45a5.67,5.67,0,0,1-5.53,0C146.39,273.6,27.33,205.72,9,137-8.08,72.94,31,14,95.75,19.34a103.13,103.13,0,0,1,49.58,17.94c7.47,5.11,15.93,11.37,20.23,16.22a4.56,4.56,0,0,0,6.26.54C191.39,38.47,266.68-21.14,320,57,320,57,113,46,192,273Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.49,112.5a4,4,0,0,1-4-3.54c-.14-1.14-3.07-28.16,13.69-47.62C54.45,49.48,69.64,43.14,89.37,42.5a4,4,0,0,1,.26,8c-17.38.56-30.6,6-39.3,16C35.85,83.27,38.45,107.8,38.47,108A4,4,0,0,1,35,112.47,3.71,3.71,0,0,1,34.49,112.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320.53,282l-2.06-7.74a97,97,0,1,0-51.86-.52l-2.22,7.68A105.7,105.7,0,0,1,210,244.18,104,104,0,0,1,188.5,180.5,105,105,0,1,1,320.53,282Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M293.5,102.5a4,4,0,0,1-4-4v-19a4,4,0,0,1,8,0v19A4,4,0,0,1,293.5,102.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M293.5,280.5a4,4,0,0,1-4-4v-19a4,4,0,0,1,8,0v19A4,4,0,0,1,293.5,280.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214,184H195a4,4,0,0,1,0-8h19a4,4,0,0,1,0,8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M392,184H373a4,4,0,0,1,0-8h19a4,4,0,0,1,0,8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M315.5,180.5a22,22,0,1,1-8.16-17.1A22,22,0,0,1,315.5,180.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M308.53,168.44a4,4,0,0,1-2.83-6.83l39-38.94a4,4,0,1,1,5.66,5.66l-39,38.94A4,4,0,0,1,308.53,168.44Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M326.67,271.77v38.12a23.1,23.1,0,0,1-20.64,23,22.31,22.31,0,0,1-2.47.13H281.37a23.11,23.11,0,0,1-23-23.11V271.07a128.86,128.86,0,0,0,68.34.7Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M310.25,319.9v50.35a16.75,16.75,0,0,1-33.5,0V320.61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBpFill);
export default __webpack_public_path__ + "static/media/Icons_BP Fill.6f0ed81f81b4509e6e4593d1e1bfefff.svg";
export { ForwardRef as ReactComponent };